import React from 'react'
import { Row } from '@fs/zion-ui'

// This wraps our use of Row in the sidesheet BUT also the bottom sheet. Because the specs are so finickey, we put them all here, in one place.

export default function RowWrapper({ children, alignY }) {
  return (
    <Row gutters="sm" guttersY="none" wrap alignX="start" alignY={alignY}>
      {children}
    </Row>
  )
}
